import type { IconSvgObject } from './types';

const TextSquareIcon: IconSvgObject = [
  ["path", { d: "M21.5 4.5C21.5 3.39543 20.6046 2.5 19.5 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V4.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13.5 17H10.5M12 7L12 17M8 8.5V8C8 7.44772 8.44772 7 9 7H15C15.5523 7 16 7.44772 16 8V8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TextSquareIcon;
